module.exports = __webpack_public_path__ + "img/KIR.3a697b47.svg";